import { createSlice } from '@reduxjs/toolkit';

/**
 * Interface for the insights Redux state
 */
export interface InsightsState {
  /** Currently selected insight ID for editing */
  currentInsightId: string | null;
  /** Whether the user is currently duplicating an insight */
  isDuplicatingInsight: boolean;
}

const defaultState: InsightsState = { currentInsightId: null, isDuplicatingInsight: false };

const slice = createSlice({
  name: 'insights',
  initialState: defaultState,
  reducers: {
    /**
     * Sets the current insight ID for editing
     * @param state - Current insights state
     * @param action - Action containing the insight ID
     */
    setCurrentInsightId: (state, action) => {
      state.currentInsightId = action.payload;
    },
    /**
     * Sets the duplication state for insights
     * @param state - Current insights state
     * @param action - Action containing the duplication boolean
     */
    setIsDuplicatingInsight: (state, action) => {
      state.isDuplicatingInsight = action.payload;
    },
    /**
     * Resets all insights state to default values
     * @param state - Current insights state
     */
    resetInsightsState: (state) => {
      state.currentInsightId = defaultState.currentInsightId;
      state.isDuplicatingInsight = defaultState.isDuplicatingInsight;
    },
  },
});

export const { setCurrentInsightId, setIsDuplicatingInsight, resetInsightsState } = slice.actions;

export default slice.reducer;
